export default __webpack_public_path__ + "c73b710f85432a4ae85e63f8600bb961.png";